import type { ExceptionField } from '@/api/cockpit';

export function isSimpleMappedSelectField(field: ExceptionField): boolean {
  return (
    (field.key === 'payment_terms' ||
      field.key === 'delivery_terms' ||
      field.key === 'delivery_mode' ||
      field.key === 'legal_entity' ||
      field.key === 'site') &&
    Array.isArray(field.matchedOptions) &&
    field.matchedOptions.length > 0
  );
}
